
(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports) :
  typeof define === 'function' && define.amd ? define(['exports'], factory) :
  (factory((global['fa-kit-67bf90e9a4-icons-kit-custom'] = {})));
}(this, (function (exports) { 'use strict';



  var faAgentGroup = {
    prefix: 'fak',
    iconName: 'agent-group',
    icon: [
512,
512,
[],
      'e00d',

      'M203.3 116c-56.1 0-101.5 44.8-101.5 100v10c0 5.5-4.6 10-10.2 10s-10.2-4.5-10.2-10V216c0-66.2 54.6-120 121.8-120s121.8 53.8 121.8 120v10c0 38.7-31.8 70-71.1 70H193.1c-11.2 0-20.3-8.9-20.3-20s9.1-20 20.3-20h20.3c11.2 0 20.3 8.9 20.3 20h20.3c28 0 50.8-22.4 50.8-50V216c0-55.2-45.4-100-101.5-100zM122.1 216c0-44.2 36.4-80 81.2-80s81.2 35.8 81.2 80c0 8.7-1.4 17.1-4 24.9c-5.3 9.1-15.2 15.1-26.5 15.1h-5.5c-7-11.9-20.1-20-35.2-20H193.1c-22.4 0-40.6 17.9-40.6 40c0 .9 0 1.7 .1 2.5c-18.6-14.6-30.5-37.2-30.5-62.5zM260.1 316c47.1 0 85.3 37.6 85.3 84c0 8.8-7.3 16-16.2 16H77.4c-8.9 0-16.2-7.2-16.2-16c0-46.4 38.2-84 85.3-84H260.1zm95.5 100h78.9c8.9 0 16.2-7.2 16.2-16c0-46.4-38.2-84-85.3-84H311.8c28.9 16.8 48.6 47.9 48.6 84c0 6-1.8 11.5-4.7 16zm-54-120h57.8c39.3 0 71.1-31.3 71.1-70V216c0-66.2-54.6-120-121.8-120c-12.2 0-24 1.8-35.1 5.1c7.8 4.5 15.1 9.8 21.8 15.8c4.4-.6 8.8-.8 13.3-.8c56.1 0 101.5 44.8 101.5 100v10c0 27.6-22.7 50-50.8 50H339.2c0-6-2.6-11.3-6.8-15c-6.7 14.4-17.4 26.5-30.7 35zm37-54.9c6.3 3.5 11.6 8.7 15.3 14.9h5.5c11.3 0 21.2-6.1 26.5-15.1c2.6-7.8 4-16.2 4-24.9c0-42.7-33.9-77.6-76.7-79.9c16.8 22.2 26.8 49.8 26.8 79.9v10c0 5.2-.5 10.2-1.4 15.1z'

    ]
  };

  exports.faAgentGroup = faAgentGroup;




  var faCustomer = {
    prefix: 'fak',
    iconName: 'customer',
    icon: [
512,
512,
[],
      'e00b',

      'M199.3 256c6.5-9.7 16.9-16.6 29-18.5c0 0 0 0 .1 0l26.9-4.1c14.8-14.5 24-34.9 24-57.4c0-44.2-35.5-80-79.3-80s-79.3 35.8-79.3 80c0 44 35.1 79.6 78.7 80zm-6.2 34.1c-14.8-1-28.8-5-41.6-11.2l-5.9 0c-45 0-81.6 36.9-81.6 82.3l0 20.6C64 400.6 79.2 416 98 416l134.1 0c-1.6-5.9-1.9-12.1-.9-18.2c0 0 0 0 0-.1l8.4-51.2-35.2-36c-5.7-5.8-9.5-13-11.2-20.6zm155.1-90.2c-2.2-4.8-7-7.9-12.2-7.9s-9.9 3.1-12.2 7.9l-27.3 57.9L235.6 267c-5.1 .8-9.3 4.5-10.9 9.5s-.3 10.6 3.4 14.3l44.2 45.1-10.4 63.7c-.8 5.3 1.3 10.6 5.5 13.7s9.8 3.5 14.3 1l54.4-30 54.4 30c4.6 2.5 10.1 2.1 14.3-1s6.3-8.4 5.5-13.7l-10.5-63.7L444 290.8c3.6-3.7 5-9.3 3.4-14.3s-5.8-8.7-10.9-9.5l-61-9.3-27.3-57.9z'

    ]
  };

  exports.faCustomer = faCustomer;




  var faCustomerGroup = {
    prefix: 'fak',
    iconName: 'customer-group',
    icon: [
512,
512,
[],
      'e00c',

      'M104 227.6c26.5 0 48-22.3 48-49.8s-21.5-49.8-48-49.8s-48 22.3-48 49.8s21.5 49.8 48 49.8zm57.8 39.4c-8.7-8.9-20.6-14.5-33.8-14.5H80c-26.5 0-48 22.3-48 49.8v24.9C32 340.9 42.7 352 56 352h49.4c4.7-36.9 26.2-67.9 56.4-85.1zM263.3 256c6.5-9.7 16.9-16.6 29-18.5c0 0 0 0 .1 0l26.9-4.1c14.8-14.5 24-34.9 24-57.4c0-44.2-35.5-80-79.3-80s-79.3 35.8-79.3 80c0 44 35.1 79.6 78.7 80zm-6.2 34.1c-14.8-1-28.8-5-41.6-11.2l-5.9 0c-45 0-81.6 36.9-81.6 82.3l0 20.6c0 18.9 15.2 34.3 34 34.3l134.1 0c-1.6-5.9-1.9-12.1-.9-18.2c0 0 0 0 0-.1l8.4-51.2-35.2-36c-5.7-5.8-9.5-13-11.2-20.6zm155.1-90.2c-2.2-4.8-7-7.9-12.2-7.9s-9.9 3.1-12.2 7.9l-27.3 57.9L299.6 267c-5.1 .8-9.3 4.5-10.9 9.5s-.3 10.6 3.4 14.3l44.2 45.1-10.4 63.7c-.8 5.3 1.3 10.6 5.5 13.7s9.8 3.5 14.3 1l54.4-30 54.4 30c4.6 2.5 10.1 2.1 14.3-1s6.3-8.4 5.5-13.7l-10.5-63.7L508 290.8c3.6-3.7 5-9.3 3.4-14.3s-5.8-8.7-10.9-9.5l-61-9.3-27.3-57.9z'

    ]
  };

  exports.faCustomerGroup = faCustomerGroup;




  var faCustomersNavIcon = {
    prefix: 'fak',
    iconName: 'customers-nav-icon',
    icon: [
672,
512,
[],
      'e00e',

      'M115.9 210.3c37.5 0 67.9-33 67.9-73.5s-30.5-73.5-67.9-73.5s-67.9 33-67.9 73.5s30.5 73.5 67.9 73.5zm81.8 58.1c-12.3-13.2-29.2-21.4-47.9-21.4H81.9C44.5 247 14 280 14 320.6v36.8c0 20.3 15.2 36.8 34 36.8h70c6.7-54.4 37-100.3 79.8-125.7zm97.9-26.8c9.1-8.7 20.8-14.6 33.8-16.7l.1 0 70.1-10.7 31.8-67.6c5-10.5 12.8-19.5 22.4-25.8C447.7 61.9 400.2 16 342.4 16c-62.1 0-112.3 52.9-112.3 118.2c0 47.8 26.9 88.9 65.6 107.5zm-19.8 45.5c-.7-.4-1.5-.7-2.2-1.1l-8.3 0c-63.8 0-115.5 54.4-115.5 121.5l0 30.4c0 28 21.6 50.6 48.1 50.6l137.2 0c-2.3-8.7-2.8-17.8-1.4-26.9c0 0 0-.1 0-.1l12.4-75.6L294.2 333c-12.3-12.5-18.5-29.2-18.3-45.8zM506.6 169.4c-3.3-7.1-10.3-11.6-18-11.6s-14.7 4.5-18 11.6l-40.3 85.5-90 13.7c-7.5 1.2-13.8 6.6-16.1 14s-.4 15.6 5 21.1l65.3 66.6L379 464.5c-1.3 7.8 1.9 15.6 8.1 20.2s14.4 5.2 21.2 1.5l80.4-44.3L569 486.2c6.8 3.7 15 3.2 21.2-1.5s9.3-12.5 8.1-20.2l-15.5-94.1L648 303.7c5.4-5.5 7.3-13.7 5-21.1s-8.6-12.9-16.1-14l-90-13.7-40.3-85.5z'

    ]
  };

  exports.faCustomersNavIcon = faCustomersNavIcon;




  var faEdgetierAi = {
    prefix: 'fak',
    iconName: 'edgetier-ai',
    icon: [
564,
512,
[],
      'e007',

      'M282 153.6A76.8 76.8 0 1 1 282 0a76.8 76.8 0 1 1 0 153.6zM282 512a76.8 76.8 0 1 1 0-153.6A76.8 76.8 0 1 1 282 512zM102.8 332.8a76.8 76.8 0 1 1 0-153.6 76.8 76.8 0 1 1 0 153.6zm358.4 0a76.8 76.8 0 1 1 0-153.6 76.8 76.8 0 1 1 0 153.6z'

    ]
  };

  exports.faEdgetierAi = faEdgetierAi;




  var faFaConfusion = {
    prefix: 'fak',
    iconName: 'fa-confusion',
    icon: [
512,
512,
[],
      'e002',

      'M308.9 5.5C291.8 1.9 274.1 0 256 0C114.6 0 0 114.6 0 256S114.6 512 256 512c141.4 0 255.9-114.5 256-255.9c-15.4 9.2-32.4 16-50.5 19.8c-10 104.6-98.3 186.6-205.5 186.6C142.1 462.5 49.5 369.9 49.5 256S142.1 49.5 256 49.5c7.8 0 15.5 .4 23 1.3c7.4-16.8 17.5-32.1 29.9-45.4zM154.6 345.8c-11.4 3-18.1 14.7-15.1 26.1s14.7 18.1 26.1 15.1l197.8-53c11.4-3 18.1-14.7 15.1-26.1s-14.7-18.1-26.1-15.1l-197.8 53zM143.4 206.5a33 33 0 1 1 66.1 0 33 33 0 1 1 -66.1 0zm135.9 0a33 33 0 1 1 66.1 0 33 33 0 1 1 -66.1 0zm123.7-65.6l.4 3.5h51.3v-6.1c0-4.3 .7-8.1 2.2-11.1c1.5-3.2 4.1-6.3 7.8-9.3c3.8-3 9-6.4 15.8-10.3c7.4-4.2 13.5-8.7 18.1-13.5s8-9.9 10.1-15.5c2.2-5.7 3.3-12 3.3-18.9v-.3c0-12.1-3.1-22.5-9.4-31.4c-6.3-9-15.1-15.9-26.5-20.7C464.7 2.5 451.3 0 435.9 0c-16 0-29.8 2.6-41.4 7.8S374.1 20.5 367.8 30.2c-6.3 9.6-9.4 21.1-9.4 34.3v.3l53.7-.1h.3c0-4 .8-7.4 2.5-10.4c1.7-3.1 4-5.4 6.9-7.1c3-1.7 6.4-2.6 10.1-2.6s7.1 .7 10 2.2c3 1.3 5.3 3.2 6.9 5.6c1.7 2.4 2.6 5.2 2.6 8.4V61c0 3.9-.7 7.2-2 10.1c-1.3 2.8-3.9 5.6-7.5 8.5c-3.7 2.8-8.9 6.2-15.8 10.1c-6.7 3.9-11.9 8.1-15.8 12.6c-3.8 4.5-6.2 9.9-7.4 16.1c-1.2 6.1-1.2 13.5 0 22.4zm3.2 68.4c5.7 4.8 13.7 7.2 24 7.2c10.4 0 18.4-2.4 24-7.2c5.7-4.9 8.5-11.9 8.5-21c0-9.2-2.8-16.2-8.5-21c-5.6-4.9-13.6-7.4-24-7.4c-10.3 0-18.3 2.5-24 7.4c-5.7 4.8-8.5 11.8-8.5 21c0 9.1 2.8 16.1 8.5 21z'

    ]
  };

  exports.faFaConfusion = faFaConfusion;




  var faFaConfusionSolid = {
    prefix: 'fak',
    iconName: 'fa-confusion-solid',
    icon: [
512,
512,
[],
      'e003',

      'M366.3 111.5c-2.1 11.2-1.8 22.9-.3 34l1.5 11.7c-5.1 9.9-7.1 20.7-7.1 31c0 17.4 5.9 35.7 21.4 49.1l.3 .2c14.6 12.4 32.3 16.1 48.1 16.1c15.7 0 33.7-3.6 48.3-16.3c0 0 0 0 0 0c15.5-13.4 21.4-31.7 21.4-49.1c0-4.8-.5-9.8-1.4-14.7c8.8 25.8 13.5 53.5 13.5 82.4c0 141.4-114.6 256-256 256S0 397.4 0 256S114.6 0 256 0c27.6 0 54.1 4.4 79 12.4c-9.6 15.9-13.9 33.7-13.9 52.1l0 37.6 47.6-.1c-1 3.1-1.8 6.3-2.4 9.5zM176.4 239.5a33 33 0 1 0 0-66.1 33 33 0 1 0 0 66.1zM139.5 371.9c3 11.4 14.7 18.1 26.1 15.1l197.8-53c11.4-3 18.1-14.7 15.1-26.1s-14.7-18.1-26.1-15.1l-197.8 53c-11.4 3-18.1 14.7-15.1 26.1zM345.3 206.5a33 33 0 1 0 -66.1 0 33 33 0 1 0 66.1 0zm57.6-65.6l.4 3.5h51.3v-6.1c0-4.3 .7-8.1 2.2-11.1c1.5-3.2 4.1-6.3 7.8-9.3c3.8-3 9-6.4 15.8-10.3c7.4-4.2 13.5-8.7 18.1-13.5s8-9.9 10.1-15.5c2.2-5.7 3.3-12 3.3-18.9v-.3c0-12.1-3.1-22.5-9.4-31.4c-6.3-9-15.1-15.9-26.5-20.7C464.7 2.5 451.3 0 435.9 0c-16 0-29.8 2.6-41.4 7.8S374.1 20.5 367.8 30.2c-6.3 9.6-9.4 21.1-9.4 34.3v.3l53.7-.1h.3c0-4 .8-7.4 2.5-10.4c1.7-3.1 4-5.4 6.9-7.1c3-1.7 6.4-2.6 10.1-2.6s7.1 .7 10 2.2c3 1.3 5.3 3.2 6.9 5.6c1.7 2.4 2.6 5.2 2.6 8.4V61c0 3.9-.7 7.2-2 10.1c-1.3 2.8-3.9 5.6-7.5 8.5c-3.7 2.8-8.9 6.2-15.8 10.1c-6.7 3.9-11.9 8.1-15.8 12.6c-3.8 4.5-6.2 9.9-7.4 16.1c-1.2 6.1-1.2 13.5 0 22.4zm3.2 68.4c5.7 4.8 13.7 7.2 24 7.2c10.4 0 18.4-2.4 24-7.2c5.7-4.9 8.5-11.9 8.5-21c0-9.2-2.8-16.2-8.5-21c-5.6-4.9-13.6-7.4-24-7.4c-10.3 0-18.3 2.5-24 7.4c-5.7 4.8-8.5 11.8-8.5 21c0 9.1 2.8 16.1 8.5 21z'

    ]
  };

  exports.faFaConfusionSolid = faFaConfusionSolid;




  var faHandHoldingHeartOutline = {
    prefix: 'fak',
    iconName: 'hand-holding-heart-outline',
    icon: [
561,
512,
[],
      'e009',

      'M398.8 142.6c28-28.4 28-74.5 0-102.9s-73.3-28.4-101.3 0L280.6 56.9 263.7 39.7c-28-28.4-73.3-28.4-101.3 0s-28 74.5 0 102.9l96.8 98.3c5.9 6 13.6 9 21.4 9s15.5-3 21.4-9l96.8-98.3zM376.4 347.4c7.5 0 14.9 2.2 21.1 6.4l76.1 50.8c3.7 2.5 8.2 3.8 12.7 3.8H532c12.7 0 22.9-10.2 22.9-22.9s-10.2-22.9-22.9-22.9H493.3L423 315.8c-13.8-9.2-30-14.1-46.6-14.1H227.3c-33.6 0-61 27.3-61 61c0 .7 0 1.2 0 1.9l-61.8-38.1c-10.2-6.3-21.8-9.5-33.8-9.5h-7c-31.7 0-57.4 25.7-57.4 57.4c0 19.4 9.9 37.6 26.2 48.2l91 59c18.5 12 40.1 18.4 62.1 18.4l346.5-.1c12.7 0 22.9-10.2 22.9-22.9s-10.2-22.9-22.9-22.9H185.6c-13.2 0-26.2-3.8-37.2-11l-91-59c-3.3-2.2-5.3-5.8-5.3-9.8c0-6.5 5.2-11.7 11.7-11.7h7c3.4 0 6.9 1 9.8 2.8l89 54.8c3.6 2.2 7.7 3.4 12 3.4h45.7 22.9 61c12.7 0 22.9-10.2 22.9-22.9s-10.2-22.9-22.9-22.9h-61H227.4c-8.4 0-15.2-6.9-15.2-15.2s6.9-15.2 15.2-15.2H376.5l-.1 .1z'

    ]
  };

  exports.faHandHoldingHeartOutline = faHandHoldingHeartOutline;




  var faHandHoldingHeartSolid = {
    prefix: 'fak',
    iconName: 'hand-holding-heart-solid',
    icon: [
561,
512,
[],
      'e008',

      'M398.7 142.6c28-28.4 28-74.5 0-102.9s-73.3-28.4-101.3 0L280.5 56.9 263.6 39.7c-28-28.4-73.3-28.4-101.3 0s-28 74.5 0 102.9l96.8 98.3c5.9 6 13.6 9 21.4 9s15.5-3 21.4-9l96.8-98.3zM13.6 332.5c-12.5 17-8.9 40.8 8.1 53.2l120.6 88.9c22.3 16.4 49.1 25.2 76.9 25.2H371.9 524.3c16.9 0 30.5-13.6 30.5-30.5v-61c0-16.9-13.6-30.5-30.5-30.5h-35l-42.8-34.3C424.9 326.3 398 317 370.3 317H295.7 280.5h-61c-16.9 0-30.5 13.6-30.5 30.5s13.6 30.5 30.5 30.5h61 15.2c8.4 0 15.2 6.9 15.2 15.2s-6.9 15.2-15.2 15.2H180.9l-114-84c-17-12.5-40.8-8.9-53.2 8.1zm356.8 45.4h.9c-.3 0-.6 0-.9 0z'

    ]
  };

  exports.faHandHoldingHeartSolid = faHandHoldingHeartSolid;




  var faSkipbackward10 = {
    prefix: 'fak',
    iconName: 'skipbackward10',
    icon: [
549,
512,
[],
      'e006',

      'M377.9 138c-56.9-56.9-148.8-57.1-206-.9l37.7 37.6c6.3 6.3 8.1 15.7 4.8 24s-11.4 13.5-20.3 13.5H84.8 77c-12.2 0-21.9-9.8-21.9-21.9V73.2c0-8.9 5.3-16.9 13.5-20.3s17.6-1.6 24 4.8l38 38c80.1-79.1 209.1-78.8 288.7 .9c22.3 22.3 38.4 48.5 48.3 76.6c5.4 15.3-2.7 31.9-17.8 37.3s-31.9-2.7-37.3-17.8c-7-19.9-18.5-38.7-34.6-54.7zM158.3 462.4V308h-3l-51.7 32.6V289.4l54.8-34.9h64.2V462.4H158.3zm214.9 5.8c-19.9 0-37-4.4-51.4-13.3c-14.4-8.9-25.5-21.6-33.3-37.9c-7.8-16.4-11.7-35.9-11.7-58.5v-.3c0-22.6 3.9-42 11.7-58.4s18.9-28.9 33.3-37.7c14.4-8.9 31.6-13.4 51.4-13.4s37 4.5 51.3 13.4c14.4 8.8 25.5 21.4 33.1 37.7c7.8 16.3 11.6 35.8 11.6 58.4v.3c0 22.6-3.9 42.1-11.6 58.5c-7.7 16.3-18.7 29-33.1 37.9c-14.3 8.8-31.4 13.3-51.3 13.3zm0-46.1c6.8 0 12.5-2.5 17.1-7.3s8.1-12.1 10.4-21.5c2.4-9.5 3.6-21.1 3.6-34.7v-.3c0-13.7-1.2-25.3-3.6-34.7c-2.3-9.4-5.8-16.5-10.4-21.3c-4.6-4.9-10.3-7.3-17.1-7.3s-12.5 2.4-17.1 7.3c-4.6 4.8-8.2 11.9-10.6 21.3s-3.6 21-3.6 34.7v.3c0 13.6 1.2 25.2 3.6 34.7c2.4 9.4 6 16.6 10.6 21.5s10.3 7.3 17.1 7.3z'

    ]
  };

  exports.faSkipbackward10 = faSkipbackward10;




  var faSkipforward10 = {
    prefix: 'fak',
    iconName: 'skipforward10',
    icon: [
549,
512,
[],
      'e005',

      'M146.4 138c56.9-56.9 148.8-57.1 206-.9l-37.7 37.6c-6.3 6.3-8.1 15.7-4.8 24s11.4 13.5 20.3 13.5H439.6h7.8c12.2 0 21.9-9.8 21.9-21.9V73.2c0-8.9-5.3-16.9-13.5-20.3s-17.6-1.6-24 4.8l-38 38C313.7 16.6 184.7 16.9 105 96.6c-22.3 22.3-38.4 48.5-48.3 76.6c-5.4 15.3 2.7 31.9 17.8 37.3s31.9-2.7 37.3-17.8c7-19.9 18.5-38.7 34.6-54.7zM109.8 462.4V308h-3L55.1 340.5V289.4l54.8-34.9H174V462.4H109.8zm214.9 5.8c-19.9 0-37-4.4-51.4-13.3C258.8 446 247.7 433.4 240 417c-7.8-16.4-11.7-35.9-11.7-58.5v-.3c0-22.6 3.9-42 11.7-58.4s18.9-28.9 33.3-37.7c14.4-8.9 31.6-13.4 51.4-13.4s37 4.5 51.3 13.4c14.4 8.8 25.5 21.4 33.1 37.7c7.8 16.3 11.6 35.8 11.6 58.4v.3c0 22.6-3.9 42.1-11.6 58.5c-7.7 16.3-18.7 29-33.1 37.9c-14.3 8.8-31.4 13.3-51.3 13.3zm0-46.1c6.8 0 12.5-2.5 17.1-7.3s8.1-12.1 10.4-21.5c2.4-9.5 3.6-21.1 3.6-34.7v-.3c0-13.7-1.2-25.3-3.6-34.7c-2.3-9.4-5.8-16.5-10.4-21.3c-4.6-4.9-10.3-7.3-17.1-7.3s-12.5 2.4-17.1 7.3c-4.6 4.8-8.2 11.9-10.6 21.3s-3.6 21-3.6 34.7v.3c0 13.6 1.2 25.2 3.6 34.7c2.4 9.4 6 16.6 10.6 21.5s10.3 7.3 17.1 7.3z'

    ]
  };

  exports.faSkipforward10 = faSkipforward10;


Object.defineProperty(exports, '__esModule', { value: true });
})));


